import { v4 as uuidv4 } from "uuid";

import { WorkspaceDataplane } from "src/clients/flow-api";

export const getCloudFormationStackLink = (
  stackName: string,
  region: string,
) => {
  return `https://${
    region ? region : ""
  }.console.aws.amazon.com/cloudformation/home?region=${region}#/stacks?filteringText=${stackName}&filteringStatus=active&viewNested=true`;
};

export const getLambdaLink = (region: string, lambdaName: string) => {
  return `https://console.aws.amazon.com/lambda/home?region=${region}#/functions/${lambdaName}?tab=configuration`;
};

export const getS3BucketLink = (bucketName: string, region: string) => {
  return `https://${region}.console.aws.amazon.com/s3/buckets/${bucketName}?region=${region}&bucketType=general&tab=objects`;
};

export const getAgentLogsInsightsLink = (
  stackName: string,
  region: string,
  sessionId?: string,
) => {
  // Convert stack name to underscore format for AgentRunner log group
  const stackNameUnderscored = stackName.replace(/-/g, "_");

  // Use log group name prefixes (not ARNs) with Logs Insights "name prefix" query scope
  const legacyAgentManagementLogGroupPrefix = `/aws/lambda/agent-management/${stackName}-agents-v2`;
  const legacyAgentRunnerLogGroupPrefix = `/aws/bedrock-agentcore/runtimes/agent_runner_${stackNameUnderscored}_agents`;
  const currentAgentManagementLogGroupPrefix = `/aws/lambda/agent-management/agents-${stackName}`;
  const currentAgentRunnerLogGroupPrefix = `/aws/bedrock-agentcore/runtimes/agent_runner_agents_${stackNameUnderscored}`;

  // Encode for CloudWatch URL format
  // CloudWatch uses * as escape character: *3a for :, *2f for /, *20 for space, etc
  const encodeForCloudWatch = (str: string) => {
    return str
      .replace(/:/g, "*3a")
      .replace(/\//g, "*2f")
      .replace(/ /g, "*20")
      .replace(/@/g, "*40")
      .replace(/\|/g, "*7c")
      .replace(/\n/g, "*0a")
      .replace(/,/g, "*2c");
  };

  const encodedLegacyAgentManagementLogGroupPrefix = encodeForCloudWatch(
    legacyAgentManagementLogGroupPrefix,
  );
  const encodedCurrentAgentManagementLogGroupPrefix = encodeForCloudWatch(
    currentAgentManagementLogGroupPrefix,
  );
  const encodedLegacyAgentRunnerLogGroupPrefix = encodeForCloudWatch(
    legacyAgentRunnerLogGroupPrefix,
  );
  const encodedCurrentAgentRunnerLogGroupPrefix = encodeForCloudWatch(
    currentAgentRunnerLogGroupPrefix,
  );

  // Build query string with optional session ID filter
  let query = "fields @timestamp, @message\n";
  if (sessionId) {
    query += `| filter @message like /${sessionId}/\n`;
  }
  query += "| sort @timestamp desc\n| limit 10000";
  const encodedQuery = encodeForCloudWatch(query);

  // Generate a random query ID
  const queryId = uuidv4();

  // Build URL using log group prefixes (allows matching log groups with dynamic suffixes)
  const urlParams = `end~0~start~-3600~timeType~'RELATIVE~tz~'LOCAL~unit~'seconds~editorString~'${encodedQuery}~queryId~'${queryId}~source~(~'${encodedLegacyAgentManagementLogGroupPrefix}~'${encodedCurrentAgentManagementLogGroupPrefix}~'${encodedLegacyAgentRunnerLogGroupPrefix}~'${encodedCurrentAgentRunnerLogGroupPrefix})~lang~'CWLI~logClass~'STANDARD~accountIDs~(~'All)~queryBy~'logGroupPrefix`;

  return `https://${region}.console.aws.amazon.com/cloudwatch/home?region=${region}#logsV2:logs-insights$3FqueryDetail$3D~(${urlParams})`;
};

export const getInfoEndpoint = (workspace: WorkspaceDataplane) => {
  return `https://${workspace.base_url}/_info`;
};

export const getMcpEndpoint = (workspace: WorkspaceDataplane) => {
  return `https://${workspace.base_url}/mcp`;
};
